<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    :style="style"
    viewBox="0 0 20 21">
    <title :id="iconName">{{ iconName }} {{ direction }} icon</title>
    <g :fill="iconColor">
      <path d="M15.498 15L17 13.614 12 9l-5 4.614L8.502 15 12 11.772z" />
    </g>
  </svg>
</template>

<script>
const arrowDirections = {
  up: "rotate(0deg)",
  right: "rotate(90deg)",
  left: "rotate(270deg)",
  down: "rotate(180deg)",
};

export default {
  props: {
    iconName: {
      type: String,
      default: "arrow",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 21,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
    direction: {
      type: String,
      default: "up", // up, right, left, down
    },
  },

  computed: {
    style() {
      return `transform: ${arrowDirections[this.direction]}`;
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  transition: transform 0.1s;
}
</style>
